define([
    "underscore",
    "backbone",
    "backbone.form"
], function (_, Backbone) {
    return Backbone.Form.extend({
        // we don't use url
        url: "/rest_account/validate_change_leverage_form",

        validation: {
            mt4_account_no: {
                required: true,
                min: 10000
            },
            leverage: {
                required: true,
                // oneOf: ['1', '10', '25', '50', '100', '200', '300', '400', '500']
            }
        },

        labels: {
            mt4_account_no: "MT4 Account No.",
            leverage: "Leverage"
        }
    });
});
